import React from "react";
import { usePromiseTracker } from "react-promise-tracker";
import { Loader } from "./Loader";

export default function PromiseLoader() {
  const { promiseInProgress } = usePromiseTracker();

  return promiseInProgress && <Loader show={true} />;
}
